import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm, useFieldArray } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import removeImg from "assets/svgs/close.svg";

import { FormattedMessage, useIntl } from "react-intl";
import { editSection, getSection, addSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import ImageUpload from "components/shared/ImageUpload";
import { isObjectNotEmpty } from "helpers/functions";

const DistinguishUs = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);

  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const {
    control,
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      items: section?.items,
    },
  });

  const { fields, append, remove } = useFieldArray({
    control: control,
    name: "items",
  });

  const addItems = () => {
    append({ title: { ar: "", en: "" }, description: { ar: "", en: "" } });
  };

  useEffect(() => {
    if (fields?.length === 0 && !isObjectNotEmpty(section)) {
      addItems();
    }
  }, [fields]);

  useEffect(() => {
    dispatch(
      getSection({
        page: "about",
        slug: "goals",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);
    setSelectedImage({
      preview: null,
      path: section?.image,
    });
  }, [reset, section]);

  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    if (!selectedImage?.path) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }
    data.image = selectedImage?.path;
    dispatch(
      editSection({
        slug: "goals",
        page: "about",
        data: { section: data },
      })
    );
    // if (section?.items?.length > 0) {
    // } else {
    //   const newData = { section: { title: "goals", ...data } };
    //   dispatch(
    //     addSection({
    //       page: "about",
    //       data: newData,
    //       slug: "goals",
    //     })
    //   );
    // }
  };

  useEffect(() => {
    section?.items?.forEach((item, index) => {
      setValue(`items[${index}].title.ar`, item?.title?.ar || "");
      setValue(`items[${index}].title.en`, item?.title?.en || "");
      setValue(`items[${index}].description.ar`, item?.description?.ar || "");
      setValue(`items[${index}].description.en`, item?.description?.en || "");
    });
  }, [section, setValue]);

  if (loading) return <Loader />;

  return (
    <div className="acc-form">
      <div className="card">
        <div className="card-head">
          <h4>
            <FormattedMessage id={"distinguishUs"} />
          </h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>
              <Col lg={12} xs={12}>
                <div className="form-group required">
                  <h5>
                    <FormattedMessage id={"image"} />
                  </h5>
                  <ImageUpload
                    selectedImage={selectedImage}
                    setSelectedImage={setSelectedImage}
                  />
                </div>
              </Col>
            </Row>
            {fields.length > 0 &&
              fields.map((item, index) => (
                <div className="add-multi-component" key={item.id}>
                  <Row>
                    {/* Arabic Title Input */}
                    <Col lg={6} xs={12}>
                      <div className="form-group">
                        <h5>
                          <FormattedMessage id={"title"} />

                          <>
                            {" "}
                            (<FormattedMessage id={"arabic-language"} />){" "}
                          </>
                        </h5>
                        <input
                          name={`items[${index}].title.ar`}
                          type="text"
                          className="form-control form-outline"
                          {...register(`items[${index}].title.ar`, {
                            required: formatMessage({ id: "requiredField" }),
                            minLength: {
                              value: 3,
                              message: formatMessage({ id: "minLength" }),
                            },
                            maxLength: {
                              value: 100,
                              message: formatMessage({ id: "maxLength" }),
                            },
                          })}
                        />

                        {errors?.items?.[index]?.title?.ar?.message && (
                          <p className="error-hint">
                            {errors?.items?.[index]?.title?.ar?.message}
                          </p>
                        )}
                      </div>
                    </Col>
                    {/* =========================================================================================== */}

                    {/* English Title Input */}

                    <Col lg={6} xs={12}>
                      <div className="form-group">
                        <h5>
                          <FormattedMessage id={"title"} />

                          <>
                            {" "}
                            (<FormattedMessage id={"english-language"} />){" "}
                          </>
                        </h5>
                        <input
                          name={`items[${index}].title.en`}
                          type="text"
                          className="form-control form-outline"
                          {...register(`items[${index}].title.en`, {
                            required: formatMessage({ id: "requiredField" }),
                            minLength: {
                              value: 3,
                              message: formatMessage({ id: "minLength" }),
                            },
                            maxLength: {
                              value: 100,
                              message: formatMessage({ id: "maxLength" }),
                            },
                          })}
                        />

                        {errors?.items?.[index]?.title?.en?.message && (
                          <p className="error-hint">
                            {errors?.items[index]?.title?.en?.message}
                          </p>
                        )}
                      </div>
                    </Col>
                    {/* =========================================================================================== */}

                    <Col xxl={6} xs={12}>
                      <div className="form-group">
                        <h5>
                          <FormattedMessage id={"description"} />

                          <>
                            {" "}
                            (<FormattedMessage id={"arabic-language"} />){" "}
                          </>
                        </h5>
                        <textarea
                          name={`items[${index}].description.ar`}
                          type="text"
                          className="form-control form-outline"
                          {...register(`items[${index}].description.ar`, {
                            required: formatMessage({ id: "requiredField" }),
                            minLength: {
                              value: 3,
                              message: formatMessage({ id: "minLength" }),
                            },
                            maxLength: {
                              value: 250,
                              message: formatMessage({ id: "maxLength" }),
                            },
                          })}
                        />

                        {errors?.items?.[index]?.description?.ar?.message && (
                          <p className="error-hint">
                            {errors?.items[index]?.description?.ar?.message}
                          </p>
                        )}
                      </div>
                    </Col>

                    {/* =========================================================================================== */}

                    <Col xxl={6} xs={12}>
                      <div className="form-group">
                        <h5>
                          <FormattedMessage id={"description"} />

                          <>
                            {" "}
                            (<FormattedMessage id={"english-language"} />){" "}
                          </>
                        </h5>
                        <textarea
                          name={`items[${index}].description.en`}
                          type="text"
                          className="form-control form-outline"
                          {...register(`items[${index}].description.en`, {
                            required: formatMessage({ id: "requiredField" }),
                            minLength: {
                              value: 3,
                              message: formatMessage({ id: "minLength" }),
                            },
                            maxLength: {
                              value: 250,
                              message: formatMessage({ id: "maxLength" }),
                            },
                          })}
                        />

                        {errors?.items?.[index]?.description?.en?.message && (
                          <p className="error-hint">
                            {errors?.items[index]?.description?.en?.message}
                          </p>
                        )}
                      </div>
                    </Col>

                    {/* Remove Button */}
                    {fields.length > 1 && (
                      <button
                        type="button"
                        onClick={() => remove(index)}
                        className="removeImg"
                      >
                        <img src={removeImg} alt="Remove" />
                      </button>
                    )}
                  </Row>
                </div>
              ))}

            <Row>
              <Col lg={4} xs={12} className="text-left mb-3">
                <button
                  type="button"
                  className="btn btn-green add_new_section__ w-100"
                  onClick={addItems}
                >
                  <FormattedMessage id={"addCollection"} />
                </button>
              </Col>
            </Row>
            <SaveChangesButton />
          </form>
        </div>
      </div>
    </div>
  );
};

export default DistinguishUs;
